import { Header, Modal } from '@procurify/ui'

import { useProcurifyIntl, useFeatureFlag } from '@webapp/hooks'
import { BudgetCategoryImporter } from './BudgetCategoryImporter'
import messages from './messages'

export interface BudgetCategoryImporterModalProps {
  open?: boolean
  onDismiss?(): void
}

export const BudgetCategoryImporterModal = ({
  open = false,
  onDismiss = () => undefined,
}: BudgetCategoryImporterModalProps) => {
  const intl = useProcurifyIntl()
  const FT_5817_ENABLE_BUDGETS_REDESIGN = useFeatureFlag(
    'FT_5817_ENABLE_BUDGETS_REDESIGN'
  )

  return (
    <Modal
      maxWidth='md'
      open={open}
      onClose={onDismiss}
      aria-labelledby='budget-category-import-modal-title'
    >
      <Modal.Card>
        <Modal.Header onClose={onDismiss}>
          <Header as='h5' id='budget-category-import-modal-title'>
            {intl.formatMessage(
              FT_5817_ENABLE_BUDGETS_REDESIGN
                ? messages.budgetsImporterModalTitle
                : messages.budgetCategoryImporterModalTitle
            )}
          </Header>
        </Modal.Header>
        <Modal.Content>
          <BudgetCategoryImporter handleModalClose={onDismiss} />
        </Modal.Content>
      </Modal.Card>
    </Modal>
  )
}
